import { S3 } from "aws-sdk";

const region = "eu-central-1";
const bucketName = "meti-documents";
const accessKeyId = "AKIAYHEANVT3OMQBWGEJ";
const secretAccessKey = "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";

const s3 = new S3({
	region,
	accessKeyId,
	secretAccessKey,
	signatureVersion: "v4",
});

// export async function secureLinkPut(imgName) {
// 	const params = {
// 		Bucket: bucketName,
// 		Key: imgName,
// 		Expires: 60,
// 	};

// 	const secureLink = await s3.getSignedUrlPromise("putObject", params);

// 	return secureLink;
// }

// export async function secureLinkRead(imgName) {
// 	// = "WhatsApp Image 2022-08-01 at 11.42.54 PM.jpeg"; //rawBytes.toString("hex");

// 	const params = {
// 		Bucket: bucketName,
// 		Key: imgName,
// 		Expires: 10,
// 	};

// 	const secureLink = await s3.getSignedUrlPromise("getObject", params);

// 	return secureLink;
// }

const { createContext, useMemo, useCallback, useEffect } = require("react");

export const S3Context = createContext({
	uploadToS3: () => {},
	readFromS3: () => {},
});

const S3Provider = ({ children }) => {
	// useEffect(() => {
	// 	const temp = async () => {
	// 		const params = {
	// 			Bucket: bucketName,
	// 			// Key: "Concert_In_G_Major_RV310_-_Vivaldi_Solo_Violin.pdf",
	// 		};

	// 		// const { response } = await s3.getObject({ params });

	// 		const response = await s3.listObjectsV2(params).promise();
	// 		// const response = await s3.getObject(params).promise();
	// 		console.log({ response });
	// 	};

	// 	temp();
	// });

	const uploadToS3 = useCallback((file, fileName) => {}, []);
	const readFromS3 = useCallback(async (fileName) => {
		console.log("READING...");
		const params = {
			Bucket: bucketName,
			// Key: "Concert_In_G_Major_RV310_-_Vivaldi_Solo_Violin.pdf",
		};

		// const { response } = await s3.getObject({ params });

		// const response = await s3.listObjectsV2(params).promise();
		// const response = await s3.getObject(params).promise();
		// console.log({ response });

		// s3.getObject({ params });
	}, []);

	const value = useMemo(() => ({ uploadToS3, readFromS3 }), [uploadToS3, readFromS3]);
	return <S3Context.Provider value={value}>{children}</S3Context.Provider>;
};

export default S3Provider;
